module.exports = __webpack_public_path__ + "static/img/78073A_1_2_R_20200623_LC.7e9ed60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78073A_1_2_R_20200623_LC.png
// module id = icmm
// module chunks = 0